// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';
import VueAnalytics from 'vue-analytics';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

// Config font awesome
fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);
fontawesome.config.autoReplaceSvg = 'nest';

Vue.use(VueAnalytics, {
  id: process.env.GA_TRACKING,
  router,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  fontawesome,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js